import React from 'react'

import { cn } from '@/legacy-src/lib/utils'

import Icon from './icons/Icon'

type Props = { className?: string }

const HedepyLogo: React.FC<Props> = ({ className = '' }) => {
  return <Icon className={cn('text-secondary', className)} icon={'logo-new'} size="native" />
}

export default HedepyLogo
